export default {
  dashboard: {
    global: {
      background: '#424256',
      card: '#38394a',
      textColor: '#FFFFFF'
    },
    kindsOverview: {
      background: '#5a5a71',
      projectIconBackground: '#424256',
      card: '#49495b',
      detailButtonBackground: '#515166',
      chartLineColor: '#38384C',
      textColor: '#FFFFFF'
    }
  }
}
